export interface IPagedSortedSearchResponseModel<T, S> {
    pagedModel: IBasePagedModel;
    sortModel: IBaseSortModel<S>;
    results: T[];
}

export interface IBasePagedModel {
    pageNumber: number;
    pageSize: number;
    recordEndIndex?: number;
    recordStartIndex?: number;
    totalPages?: number;
    totalResults?: number;
}

export interface IBaseSortModel<T> {
    sortColumn: T;
    sortDirection: SortDirections;
}

export enum SortDirections
{
    Asc = 1,
    Desc = 2
}